import { render, staticRenderFns } from "./ListEventosCompacto.vue?vue&type=template&id=226e96fc&scoped=true&"
import script from "./ListEventosCompacto.vue?vue&type=script&lang=js&"
export * from "./ListEventosCompacto.vue?vue&type=script&lang=js&"
import style0 from "./ListEventosCompacto.vue?vue&type=style&index=0&id=226e96fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e96fc",
  null
  
)

export default component.exports